<div
  class="bar"
  matTooltipClass="whitespace-pre-line"
  matTooltipPosition="right"
  data-test-id="schedule-calendar-period-bar"
  [matTooltip]="tooltip()"
>
  @for (range of preferred(); track $index) {
    <span
      class="preferred"
      data-test-id="schedule-calendar-period-bar-preferred"
      [style.top.px]="range.top"
      [style.height.px]="range.height"
    ></span>
  }
</div>
